import { render, staticRenderFns } from "./TagChatContent.vue?vue&type=template&id=d9270c64"
import script from "./TagChatContent.vue?vue&type=script&lang=js"
export * from "./TagChatContent.vue?vue&type=script&lang=js"
import style0 from "./TagChatContent.vue?vue&type=style&index=0&id=d9270c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports